var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('p',{attrs:{"hidden":""}},[_vm._v("\n  application error\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }